"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareInputs = exports.isMissing = void 0;
const core_1 = require("@g17eco/core");
/** No value: absent, null or blank text */
const isMissing = (value) => value === undefined || value === null || (typeof value === 'string' && !value.trim());
exports.isMissing = isMissing;
// [{ col1: { value: 235, unit: 'kg' } }, { col1: { value: undefined } }]
const toRows = (valueType, valueData) => {
    switch (valueType) {
        case core_1.UtrValueType.Table:
            return (valueData?.table ?? []).map((row) => Object.fromEntries(
            // A blank cell is missing data, like an absent one
            row.map(({ code, value, unit, numberScale }) => [
                code,
                { value: (0, exports.isMissing)(value) ? undefined : value, unit, numberScale },
            ])));
        case core_1.UtrValueType.ValueList:
        case core_1.UtrValueType.ValueListMulti: {
            // Each chosen option is a row keyed by the option
            const data = valueData?.data;
            const options = typeof data === 'string' ? [data] : Array.isArray(data) ? data : [];
            return options.filter((option) => typeof option === 'string').map((option) => ({ [option]: { value: option } }));
        }
        default:
            return [];
    }
};
const selectAnswers = ({ context }, utrvs) => {
    switch (context) {
        case 'utrv':
            return utrvs.slice(0, 1);
        case 'all':
            return utrvs;
        case 'disaggregations':
            // A disaggregated answer is read by the value type of the answer it belongs to
            return utrvs.flatMap(({ disaggregation = [], valueType }) => disaggregation.map((answer) => ({ ...answer, valueType })));
    }
};
const prepareInputs = (input, { utr, utrvs }) => selectAnswers(input, utrvs).map((answer) => ({
    rootValue: answer.value,
    data: toRows(answer.valueType ?? utr.valueType, answer.valueData),
}));
exports.prepareInputs = prepareInputs;
